// extracted by mini-css-extract-plugin
export default {"button":"Button_button__6Y1h1","smallButton":"Button_smallButton__0kG9E"};